import React from 'react';
import PropTypes from 'prop-types';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import Helmet from 'react-helmet';
import AdminLayout from '../../src/admin/layout/components/AdminLayout';
import PageLayoutEditAdminNavbar from '../components/PageLayoutEditAdminNavbar';
import PageLayoutAdminHeader from '../components/PageLayoutAdminHeader';
import PageLayoutBuilder from '../containers/PageLayoutBuilder';

const propTypes = {
  params: PropTypes.shape({
    localeCode: PropTypes.string.isRequired,
    typeId: PropTypes.string.isRequired,
    versionId: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {};

/* eslint-disable react/prefer-stateless-function */
class PageLayoutEdit extends React.Component {
  render() {
    const { params: { localeCode, typeId, versionId } } = this.props;

    return (
          <React.Fragment>
            <Helmet title="Page Layout Editor" />
            <DndProvider backend={HTML5Backend}>
              <AdminLayout
                header={(
                  <PageLayoutAdminHeader
                    localeCode={localeCode}
                    typeId={typeId}
                    versionId={versionId}
                  />
                )}
                navbar={<PageLayoutEditAdminNavbar />}
              >
                <PageLayoutBuilder
                  localeCode={localeCode}
                  typeId={typeId}
                  versionId={versionId}
                />
              </AdminLayout>
            </DndProvider>
          </React.Fragment>
    );
  }
}

PageLayoutEdit.propTypes = propTypes;
PageLayoutEdit.defaultProps = defaultProps;

// The react-dnd dragDropContext needs to wrap the top-level component so
// dragging widgets or sections from the component library panel onto the builder
// works properly.
export default PageLayoutEdit;
